import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from './../api';
import { EGerdauService } from '../EGerdauService';
import { UserData } from './types';

export class UserEvaluationService extends EGerdauService {
  async validateUserData(userData: UserData): Promise<boolean> {
    const headers = this.getHeaders();
    const { cnpj, email, prospectUserId, requester, token } = userData;
    const url = `?cnpj=${cnpj}&email=${email}&prospectUserId=${prospectUserId}&requester=${requester}&token=${token}`;

    try {
      const response = await customersAuthorizationApi.get(
        `${ECustomerAuthorizationEndpoints.VALIDATE_LINK}${url}`,
        { headers }
      );

      return !!response.data;
    } catch (err) {
      console.error(err);
      throw new Error('Não foi possível validar os dados do link');
    }
  }

  async approveUser(userData: UserData): Promise<boolean> {
    const headers = this.getHeaders();

    try {
      const response = await customersAuthorizationApi.post(
        ECustomerAuthorizationEndpoints.APRROVE_USER,
        userData,
        { headers }
      );

      return !!response.data;
    } catch (err) {
      console.error(err);
      throw new Error('Não foi possível aprovar novo usuário');
    }
  }

  async rejectUser(userData: UserData): Promise<boolean> {
    const headers = this.getHeaders();

    try {
      const response = await customersAuthorizationApi.post(
        ECustomerAuthorizationEndpoints.REJECT_USER,
        userData,
        { headers }
      );

      return !!response.data?.success;
    } catch (err) {
      console.error(err);
      throw new Error('Não foi possível rejeitar novo usuário');
    }
  }
}
